module.exports = __webpack_public_path__ + "img/485.b14a590b.png";